import * as React from 'react';

interface IAdFoxBannerSectionProps {
  randomId: string;
  allowYandexAdsNetwork: boolean;
  className?: string;

  onClick?(): void;
}

export const AdFoxBannerSection: React.FC<IAdFoxBannerSectionProps> = ({
  children,
  randomId,
  onClick,
  allowYandexAdsNetwork,
  className,
}) => (
  <aside key={randomId} className={className || ''} onClick={onClick}>
    {children}
    {/* Пустой div для места РСЯ баннера (РСЯ баннер может быть вместо любого баннера) */}
    {!allowYandexAdsNetwork && <div id={`AdFox_banner_${randomId}`} />}
  </aside>
);
